import styled from 'styled-components';
import { Popover, Grid } from '@material-ui/core';
import { formatCurrency } from '../../utils';

const StyledGridContainer = styled(Grid)`
  max-width: 500px;
  padding: 6px;
`;

const StyledGridItemLabel = styled(Grid)`
  color: #616161;
  padding: 4px 8px;
`;

const StyledGridItem = styled(Grid)`
  color: #757575;
  padding: 4px 8px;
`;

const getListerName = (lister) => {
  if (!lister) return 'N/A';
  if (lister.role === 'seller') {
    return lister.dealership_name || 'N/A';
  }
  return lister.options?.name_for_bio || lister.first_name || 'N/A';
};

const VehicleDetailsPopover = ({ vehicleData, anchorEl, open, onClose, showLister = false }) => {
  const listerName = getListerName(vehicleData.lister);

  return (
    <Popover
      id="simple-popper"
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
    >
      <StyledGridContainer container>
        {showLister && (
          <>
            <StyledGridItemLabel item xs={6}>
              Lister:
            </StyledGridItemLabel>
            <StyledGridItem item xs={6}>
              {listerName}
            </StyledGridItem>
          </>
        )}
        <StyledGridItemLabel item xs={6}>
          Extension times:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.times_extended}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Mileage:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {formatCurrency(vehicleData.mileage).slice(1)}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Blue Book:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {formatCurrency(vehicleData.bluebook_value) + '/' + formatCurrency(vehicleData.bluebook_mileage)}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Engine:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.engine}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Transmission:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.transmission}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Check Engine Light:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.check_engine_light || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          ABS Light:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.abs_light || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Airbag Light:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.air_bag_light || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Windshield:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.windshield || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Tires:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.tires || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Paint:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.exterior_paint || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Interior:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.interior_overall || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Air Conditioning Blows:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.air_conditioning || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Engine Oil:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.oil_condition || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Engine Coolant:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.additional_info?.coolant || 'N/A'}
        </StyledGridItem>
        <StyledGridItemLabel item xs={6}>
          Dealer Comments:
        </StyledGridItemLabel>
        <StyledGridItem item xs={6}>
          {vehicleData.inspector_notes?.message || 'N/A'}
        </StyledGridItem>
      </StyledGridContainer>
    </Popover>
  );
};

export default VehicleDetailsPopover;
